import type { Role } from '@/types/User'

export const hasRole = (userRoles: Role[], requiredRoles: Role[]): boolean =>
  userRoles.some(role => requiredRoles.includes(role))
